
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import './internal-icons-3bdf43cd.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import { C as CIcon } from './index-ff45b78b.js';
import './props.types-cbb7b1ff.js';
import { C as CFlex } from './index-dbd7e06a.js';
import { f as formControlProps } from './formcontrol.props-9ed1436a.js';
import './text.utils-6bf402a1.js';
import CText from './CText.js';

/**
 * Hey! Welcome to @chakra-ui/vue CFormErrorMessage
 *
 * Receives validation information from the `CFormControl`
 * component and displays the validation message
 *
 * @see Docs     https://vue.chakra-ui.com/formcontrol
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CFormErrorMessage/CFormErrorMessage.js
 * @see WAI      https://www.w3.org/WAI/tutorials/forms/
 */
/**
 * CFormControl component
 *
 * Displays validation message content if it received
 * `isInvalid` from context
 *
 * @extends CFlex
 * @see Docs https://vue.chakra-ui.com/formcontrol
 */

var CFormErrorMessage = {
  name: 'CFormErrorMessage',
  inject: ['$chakraColorMode', '$useFormControl'],
  props: Object.assign({}, {
    icon: {
      type: String,
      default: 'warning'
    },
    as: String
  }, formControlProps),
  computed: {
    formControl: function formControl() {
      return this.$useFormControl(this.$props);
    },
    colorMode: function colorMode() {
      return this.$chakraColorMode();
    }
  },
  render: function render(h) {
    if (!this.formControl.isInvalid) {
      return null;
    }

    var color = {
      light: 'red.500',
      dark: 'red.300'
    };
    return h(CFlex, {
      props: {
        as: this.as
      },
      attrs: Object.assign({}, {
        color: color[this.colorMode],
        mt: 2,
        fontSize: 'sm',
        align: 'center',
        id: this.formControl.id ? this.formControl.id + "-error-message" : null
      }, this.$attrs, {
        'data-chakra-component': 'CFormErrorMessage'
      })
    }, [h(CIcon, {
      props: {
        name: this.icon
      },
      attrs: {
        mr: '0.5em',
        'aria-hidden': true
      }
    }), h(CText, {
      attrs: {
        lineHeight: 'normal'
      }
    }, this.$slots.default)]);
  }
};

export default CFormErrorMessage;
